import { useEffect, useState } from "react";
import api from "@/lib/api";

const LOOKUPS = [
  { k: "tipo-trattamento",       label: "Tipo Trattamento" },
  { k: "tempi-conservazione",    label: "Tempi di Conservazione" },
  { k: "tipi-nomina",            label: "Tipi Nomina" },
  { k: "trattamenti-tipi",       label: "Categoria Tipi Dato" },
  { k: "tipi-dato",              label: "Tipi Dato" },
  { k: "rischi",                 label: "Rischi" },
  { k: "misure",                 label: "Misure" },
  { k: "termini-cancellazione",  label: "Termini Cancellazione" },
  { k: "soggetti",               label: "Soggetti" },
  { k: "fasi",                   label: "Fasi" },
  { k: "motivi",                 label: "Motivo" },
  { k: "dislocazioni",           label: "Dislocazioni" },
];

const RUOLI_CANONICI = [
  { k: "", label: "— nessuno (nomina ignorata in stampa) —" },
  { k: "legale_rappresentante", label: "Legale Rappresentante (LR)" },
  { k: "titolare", label: "Titolare del trattamento (PT)" },
  { k: "responsabile", label: "Responsabile del trattamento (RE)" },
  { k: "dpo", label: "DPO (DP)" },
  { k: "controllore", label: "Controllore (CO)" },
  { k: "controllore_backup", label: "Responsabile Backup (BK)" },
  { k: "system_administrator", label: "Responsabile System Administrator (SA)" },
];
const RUOLO_LBL = Object.fromEntries(RUOLI_CANONICI.map(r => [r.k, r.label]));

export default function PrivacyTabellePage() {
  const [selected, setSelected] = useState(LOOKUPS[0].k);
  const [items, setItems] = useState([]);
  const [categorie, setCategorie] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(null);
  const [err, setErr] = useState(null);
  const [importing, setImporting] = useState(false);
  const [importResult, setImportResult] = useState(null);

  const carica = async (kind) => {
    setLoading(true); setErr(null);
    try {
      const r = await api.get(`/privacy/lookup/${kind}`);
      setItems(r.data.items || []);
      if (kind === "tipi-dato") {
        const rc = await api.get("/privacy/lookup/trattamenti-tipi");
        setCategorie(rc.data.items || []);
      }
    } catch (e) { setErr(e.response?.data?.detail || "Errore"); }
    finally { setLoading(false); }
  };
  useEffect(() => { carica(selected); /* eslint-disable-next-line */ }, [selected]);

  const salva = async () => {
    try {
      const payload = { codice: editing.codice, descrizione: editing.descrizione };
      if (selected === "tipi-dato") payload.categoria_codice = editing.categoria_codice || null;
      if (selected === "fasi" || selected === "dislocazioni") payload.nome = editing.nome || "";
      if (selected === "tipi-nomina") payload.ruolo = editing.ruolo || "";
      if (editing._isNew) await api.post(`/privacy/lookup/${selected}`, payload);
      else await api.put(`/privacy/lookup/${selected}/${encodeURIComponent(editing._orig_codice)}`, {
        descrizione: payload.descrizione,
        ...(selected === "tipi-dato" ? { categoria_codice: payload.categoria_codice } : {}),
        ...((selected === "fasi" || selected === "dislocazioni") ? { nome: payload.nome } : {}),
        ...(selected === "tipi-nomina" ? { ruolo: payload.ruolo } : {}),
      });
      setEditing(null);
      await carica(selected);
    } catch (e) { setErr(e.response?.data?.detail || "Errore"); }
  };

  const elimina = async (r) => {
    if (!window.confirm(`Eliminare "${r.codice} — ${r.descrizione}"?`)) return;
    try { await api.delete(`/privacy/lookup/${selected}/${encodeURIComponent(r.codice)}`); await carica(selected); }
    catch (e) { setErr(e.response?.data?.detail || "Errore"); }
  };

  const handleImport = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = ""; // reset in modo da poter re-selezionare lo stesso file
    if (!file) return;
    const label = LOOKUPS.find(l => l.k === selected)?.label;
    const msg = `Importare "${file.name}" nella tabella "${label}"?\n\n` +
                `• Modalità: SOSTITUZIONE COMPLETA (i dati attuali verranno cancellati e sostituiti con quelli del file)\n` +
                `• Record attuali: ${items.length}\n\n` +
                `Procedere?`;
    if (!window.confirm(msg)) return;
    setImporting(true); setErr(null); setImportResult(null);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post(`/privacy/lookup/${selected}/import-excel?mode=replace`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setImportResult(r.data);
      await carica(selected);
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Errore durante l'import");
    } finally {
      setImporting(false);
    }
  };

  const categoriaLabel = (code) => categorie.find(c => c.codice === code)?.descrizione || code;
  const selectedLabel = LOOKUPS.find(l => l.k === selected)?.label;
  const showCategoria = selected === "tipi-dato";
  const showNome = selected === "fasi" || selected === "dislocazioni";
  const showRuolo = selected === "tipi-nomina";

  return (
    <div style={{ display: "flex", height: "calc(100vh - 70px)" }}>
      {/* Sidebar */}
      <div style={{ width: 260, background: "#37474f", color: "white", padding: 12, overflowY: "auto" }}>
        <div style={{ fontSize: 11, fontWeight: 700, opacity: 0.7, marginBottom: 8, textTransform: "uppercase" }}>Tabelle Privacy</div>
        {LOOKUPS.map(l => (
          <div key={l.k} onClick={() => setSelected(l.k)} data-testid={`priv-tab-${l.k}`}
            style={{ padding: "10px 14px", cursor: "pointer", fontSize: 13, fontWeight: 700, marginBottom: 2,
              background: selected === l.k ? "#29b6f6" : "#546e7a",
              color: "white", borderRadius: 2, transition: "background 0.15s" }}>
            <span style={{ marginRight: 8 }}>›</span>{l.label}
          </div>
        ))}
      </div>

      {/* Content */}
      <div style={{ flex: 1, padding: 20, overflowY: "auto" }}>
        <div style={{ display: "flex", alignItems: "center", marginBottom: 12, gap: 8, flexWrap: "wrap" }}>
          <h2 style={{ color: "#37474f", fontSize: 18, margin: 0 }}>📑 {selectedLabel} · {items.length}</h2>
          <div style={{ marginLeft: "auto", display: "flex", gap: 8, alignItems: "center" }}>
            <label
              data-testid="priv-lk-import-btn"
              title="Importa da file Excel (.xlsx) — sostituisce i dati attuali"
              style={{
                padding: "7px 16px",
                background: importing ? "#78909c" : "#2e7d32",
                color: "white",
                fontSize: 12,
                fontWeight: 700,
                cursor: importing ? "wait" : "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
              }}>
              {importing ? "⏳ Import in corso..." : "📥 Importa Excel"}
              <input
                type="file"
                accept=".xlsx,.xlsm"
                onChange={handleImport}
                disabled={importing}
                data-testid="priv-lk-import-file"
                style={{ display: "none" }}
              />
            </label>
            <button onClick={() => setEditing({ _isNew: true, codice: "", descrizione: "" })}
              data-testid="priv-lk-new"
              style={{ padding: "7px 16px", background: "#37474f", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
              ➕ Nuovo
            </button>
          </div>
        </div>
        {importResult && (
          <div data-testid="priv-lk-import-result"
            style={{ padding: 10, background: "#e8f5e9", color: "#1b5e20", fontSize: 12, marginBottom: 10, border: "1px solid #a5d6a7" }}>
            ✅ Import completato: <b>{importResult.inserted}</b> inseriti, <b>{importResult.updated}</b> aggiornati
            {importResult.deleted ? <>, <b>{importResult.deleted}</b> sostituiti</> : null}
            {" "}(totale righe: <b>{importResult.total_rows}</b>)
            <button onClick={() => setImportResult(null)} style={{ float: "right", background: "none", border: "none", cursor: "pointer", color: "#1b5e20", fontWeight: 700 }}>✕</button>
          </div>
        )}
        {err && <div style={{ padding: 10, background: "#fff0f0", color: "#c00", fontSize: 12, marginBottom: 10 }}>{err} <button onClick={() => setErr(null)} style={{ float: "right", background: "none", border: "none", cursor: "pointer", color: "#c00", fontWeight: 700 }}>✕</button></div>}
        <div style={{ background: "white", border: "1px solid #ccc" }}>
          <table className="sw-table sw-table-compact" style={{ fontSize: 12 }}>
            <thead className="thead-blue">
              <tr>
                <th style={{ width: 40 }}>#</th>
                <th style={{ width: 140 }}>CODICE</th>
                {showNome && <th style={{ width: 220 }}>NOME</th>}
                <th>DESCRIZIONE</th>
                {showCategoria && <th style={{ width: 240 }}>CATEGORIA</th>}
                {showRuolo && <th style={{ width: 240 }}>RUOLO PRIVACY</th>}
                <th style={{ width: 100, textAlign: "center" }}>AZIONI</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={4 + (showCategoria ? 1 : 0) + (showNome ? 1 : 0) + (showRuolo ? 1 : 0)} style={{ padding: 30, textAlign: "center", color: "#888" }}>Caricamento...</td></tr>}
              {!loading && items.length === 0 && (
                <tr><td colSpan={4 + (showCategoria ? 1 : 0) + (showNome ? 1 : 0) + (showRuolo ? 1 : 0)} style={{ padding: 30, textAlign: "center", color: "#888" }}>Nessun record. Clicca <b>+ Nuovo</b> oppure usa la funzione di import Excel.</td></tr>
              )}
              {items.map((r, i) => (
                <tr key={r.codice} data-testid={`priv-lk-row-${i}`}>
                  <td style={{ textAlign: "center", color: "#888", fontFamily: "Consolas, monospace" }}>{i + 1}</td>
                  <td style={{ fontFamily: "Consolas, monospace", fontWeight: 700, color: "#0d47a1" }}>{r.codice}</td>
                  {showNome && <td style={{ fontWeight: 600, color: r.nome ? "#37474f" : "#c62828" }}>{r.nome || <i style={{ color: "#c62828" }}>— non assegnato —</i>}</td>}
                  <td>{r.descrizione}</td>
                  {showCategoria && <td style={{ fontSize: 11, color: r.categoria_codice ? "#37474f" : "#c62828" }}>{r.categoria_codice ? categoriaLabel(r.categoria_codice) : <i>— non assegnata —</i>}</td>}
                  {showRuolo && <td style={{ fontSize: 11, color: r.ruolo ? "#1b5e20" : "#c62828", fontWeight: r.ruolo ? 700 : 400 }}>{r.ruolo ? RUOLO_LBL[r.ruolo] || r.ruolo : <i style={{ color: "#c62828" }}>— non assegnato —</i>}</td>}
                  <td style={{ textAlign: "center" }}>
                    <button onClick={() => setEditing({ ...r, _orig_codice: r.codice })}
                      style={{ background: "#1565c0", color: "white", border: "none", padding: "3px 8px", fontSize: 10, fontWeight: 700, cursor: "pointer", marginRight: 4 }}>✏</button>
                    <button onClick={() => elimina(r)}
                      style={{ background: "#c62828", color: "white", border: "none", padding: "3px 8px", fontSize: 10, fontWeight: 700, cursor: "pointer" }}>🗑</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {editing && (
        <div onClick={() => setEditing(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 600, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div onClick={e => e.stopPropagation()} style={{ background: "white", width: 480, borderRadius: 4, overflow: "hidden" }}>
            <div style={{ background: "#37474f", color: "white", padding: "12px 18px", fontWeight: 700, fontSize: 14, display: "flex", justifyContent: "space-between" }}>
              {editing._isNew ? `➕ Nuovo · ${selectedLabel}` : `✏ Modifica ${editing._orig_codice}`}
              <button onClick={() => setEditing(null)} style={{ background: "none", border: "none", color: "white", fontSize: 20, cursor: "pointer" }}>✕</button>
            </div>
            <div style={{ padding: 18 }}>
              <div style={{ marginBottom: 10 }}>
                <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>CODICE *</label>
                <input value={editing.codice || ""} onChange={e => setEditing({ ...editing, codice: e.target.value.toUpperCase() })}
                  disabled={!editing._isNew} data-testid="priv-lk-m-cod"
                  style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12, fontFamily: "Consolas, monospace", fontWeight: 700 }} />
              </div>
              <div>
                <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>DESCRIZIONE *</label>
                <input value={editing.descrizione || ""} onChange={e => setEditing({ ...editing, descrizione: e.target.value })}
                  data-testid="priv-lk-m-desc"
                  style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }} />
              </div>
              {showNome && (
                <div style={{ marginTop: 10 }}>
                  <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>NOME</label>
                  <input value={editing.nome || ""} onChange={e => setEditing({ ...editing, nome: e.target.value })}
                    data-testid="priv-lk-m-nome"
                    placeholder="Nome breve identificativo della fase"
                    style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }} />
                </div>
              )}
              {showCategoria && (
                <div style={{ marginTop: 10 }}>
                  <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>CATEGORIA TRATTAMENTO</label>
                  <select value={editing.categoria_codice || ""} onChange={e => setEditing({ ...editing, categoria_codice: e.target.value })}
                    data-testid="priv-lk-m-cat"
                    style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }}>
                    <option value="">— nessuna —</option>
                    {categorie.map(c => <option key={c.codice} value={c.codice}>{c.codice} — {c.descrizione}</option>)}
                  </select>
                </div>
              )}
              {showRuolo && (
                <div style={{ marginTop: 10 }}>
                  <label style={{ fontSize: 10, fontWeight: 700, color: "#666" }}>
                    RUOLO PRIVACY <span style={{ color: "#888", fontWeight: 400 }}>(determina la sezione del modello: PT/RE/DP/CO/BK/SA)</span>
                  </label>
                  <select value={editing.ruolo || ""} onChange={e => setEditing({ ...editing, ruolo: e.target.value })}
                    data-testid="priv-lk-m-ruolo"
                    style={{ width: "100%", padding: 7, border: "1px solid #ccc", fontSize: 12 }}>
                    {RUOLI_CANONICI.map(r => <option key={r.k} value={r.k}>{r.label}</option>)}
                  </select>
                </div>
              )}
            </div>
            <div style={{ padding: "10px 18px", borderTop: "1px solid #eee", display: "flex", justifyContent: "flex-end", gap: 8 }}>
              <button onClick={() => setEditing(null)} style={{ padding: "6px 14px", background: "white", color: "#666", border: "1px solid #ccc", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>Annulla</button>
              <button onClick={salva} data-testid="priv-lk-save"
                style={{ padding: "6px 18px", background: "#37474f", color: "white", border: "none", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>💾 Salva</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
